<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <woot-modal-header
      :header-title="$t('SEND_CONTRACT.TITLE')"
      :header-content="$t('SEND_CONTRACT.DESCRIPTION')"
    />

    <div v-if="isDefaulterResponsibleWithSchool" class="p-8 text-sm text-red-400">
      {{ $t('SEND_CONTRACT.DEFAUTER_CONTACT_TOOLTIP') }}
    </div>

    <digital-acceptance-contract
      v-if="!isDefaulterResponsibleWithSchool" 
      :is-requesting-contract="uiFlags.isRequestingContract"
      :contact="contact"
      @cancel="onClose"
      @success="onSuccess"
    />
  </woot-modal>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import DigitalAcceptanceContract from 'dashboard/modules/contact/components/DigitalAcceptanceContract';

import { mapGetters } from 'vuex';
import { CONTACTS_EVENTS } from '../../helper/AnalyticsHelper/events';

export default {
  components: { DigitalAcceptanceContract },
  mixins: [alertMixin],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enrollment: null,
      isSearching: false,
      searchResults: [],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags'
    }),
    contactLabels(){
      return this.$store.getters['contactLabels/getContactLabels'](this.contact.id);
    },
    isDefaulterResponsibleWithSchool(){
      return this.contactLabels.includes('inadimplente_com_a_escola');
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onSuccess(response) {
      this.$track(CONTACTS_EVENTS.SENDED_CONTRACT);
      this.showAlert(this.$t('SEND_CONTRACT.FORM.SUCCESS_MESSAGE'));
      this.onClose();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>